<script setup lang="ts">
import { computed } from "vue"
import { TextInput } from "@hantera/design-system"
import type { AppSettingDefinitionInfo } from "@/backend/apps.types"

const props = defineProps<{
  modelValue: unknown
  definition: AppSettingDefinitionInfo
  settingKey: string
  readonly?: boolean
  hasStoredValue?: boolean
}>()

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void
}>()

const inputType = computed(() => (props.definition.secret ? "password" : "text"))

const placeholder = computed(() => {
  if (!props.definition.secret) return ""
  return props.hasStoredValue ? "••••••••" : "Not set"
})

const stringValue = computed(() => (props.modelValue as string) ?? "")
</script>

<template>
  <TextInput
    :type="inputType"
    :model-value="stringValue"
    :placeholder="placeholder"
    :readonly="readonly"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
